export {isScrollable} from '../../../src/utils/isScrollable';
